<div class="container-fluid">
  <div class="row w-100 mb-3">
    <proposals-progress-bar [status]="proposal?.status" />
  </div>
  @if (canActOnProposal && !isScopeChangePage && proposal?.status === 'ACCEPTED') {
    <div class="row w-100 mb-3">
      <proposals-scope-change [proposal]="proposal" />
    </div>
  }
  <div class="row g-3 mb-3">
    <div class="col-md-7">
      <div class="card shadow-sm mb-3">
        <div class="card-header">
          <h3 class="card-title">Generic Data</h3>
          @if (canEditProposal && proposal?.status !== 'NOT_ACCEPTED' && proposal?.status !== 'ACCEPTED') {
            <button type="button" class="btn btn-success ms-auto" (click)="goToEditProposal()" [disabled]="!proposal">
              Edit Proposal
            </button>
          }
        </div>
        <div class="card-body row gy-3">
          <proposals-form [readonlyProposalsForm]="true" [proposal]="proposal" />
          <proposals-data [readonlyProposalData]="readonly" [proposal]="proposal" />
        </div>
      </div>
      <proposals-other [proposal]="proposal" [readonlyProposalsForm]="readonly" />
    </div>
    <div class="col-md-5">
      <ranking-bar [readonlyRankingBar]="true" [ranking]="proposal?.request?.customer?.ranking" [customer]="proposal" />
      <proposals-details-form-request [readonlyProposalDetails]="readonly" [proposal]="proposal" />
    </div>

  </div>
  <div class="row g-3 mb-2">
    <div class="col-12">
      <proposals-items [items]="proposalItems" [proposalId]="proposal?.proposalId" [useDetailView]="true"
        [readonlyItems]="true" />
    </div>
    <proposals-campaigns [campaigns]="proposal?.campaigns" />
  </div>

  @if (canActOnProposal && proposal?.status === 'PENDING_CLIENT') {
    <div class="col-12 d-flex justify-content-around mb-3">
      <button type="button" class="btn btn-success me-3 fs-5" (click)="acceptProposal(confirmProjectModal)">
        Proposal accepted
      </button>
      <button type="button" class="btn btn-danger me-3 fs-5" (click)="openRejectModal()">
        Proposal not accepted
      </button>
    </div>
  }
  @if (proposal?.status === 'ACCEPTED') {
    <div class="col-12 d-flex justify-content-center mb-3">
      <button type="button" class="btn btn-primary btn-gw2 fs-5" (click)="goToProject()">
        Go to the Project
      </button>
    </div>
  }
  @if (canActOnProposal && proposal?.status === 'NOT_ACCEPTED') {
    <div class="col-12 d-flex justify-content-center mb-3">
      <button type="button" class="btn btn-primary btn-gw2 fs-5" (click)="reopenProposal()">
        Reopen Proposal
      </button>
    </div>
  }
  <div class="row g-3">
    <div class="col-sm-8">
      <notes-customers-form [readonlyCustomerNotes]="true" [customer]="proposalNotes"
        [noteServiceMethod]="proposalsService" [addNoteMethod]="'createNotes'" [deleteNoteMethod]="'deleteNotes'"
        [sectionAttribute]="'proposalId'" />
    </div>
    <div class="col-sm-4 mt-3">
      <div class="card shadow-sm mb-3">
        <div class="card-header">
          <h3 class="card-title">Proposal Archive</h3>
        </div>
        <div class="card-body">
          <proposals-attachments-panel [proposal]="proposal" [attachments]="proposal?.contractAttachments" [readonlyAttachmentsPanel]="true" />
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #rejectProposalModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Why was it not accepted?</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <textarea-field label="Reason" placeholder="Provide a reason..."
    [textareaFormControl]="reasonControl"></textarea-field>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="modal.dismiss()">Back</button>
    <button type="button" class="btn btn-danger" (click)="confirmRejection()">Confirm</button>
  </div>
</ng-template>

<ng-template #confirmProjectModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Confirm Acceptance</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to accept this proposal? A project will be automatically created by the system.</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-success" (click)="modal.close('confirm')">Confirm</button>
  </div>
</ng-template>